var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PureComponent } from 'react';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isError: false
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { isError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var captureException = this.props.captureException;
        captureException(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var fallback = this.props.fallback;
        var isError = this.state.isError;
        if (isError) {
            return fallback;
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(PureComponent));
export { ErrorBoundary };
